import React from 'react'
import TopNavBar from '../Components/TopNavBar'
import Sidebar from '../Components/Sidebar'
import HomeBody from '../Components/Home-Body'

const Home = ({isSidebarOpen , toggleSidebar}) => {
  return (
    <div className='home'>
        <TopNavBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
        <div className="body-content">
          <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
          <HomeBody/>
        </div>
    </div>
  )
}

export default Home